const styles = theme => ({
  footer: {
    padding: "30px 0",
    backgroundColor: "#f4f4f4",
    marginTop: 50
  },
  container: {
    "& > div": {
      display: "flex",
      flexWrap: "wrap",
      margin: -15,

      "& > div": {
        width: "calc(100% / 4 - 30px)",
        margin: 15,

        "& h4": {
          fontWeight: "600",
          marginBottom: 20
        }
      }
    }
  },
  info: {
    "& img": {
      height: 50,
      marginBottom: 10
    },

    "& h5": {
      color: "#555",
      marginBottom: 10,
      lineHeight: 1.7
    },

    "& .social": {
      width: 30,
      height: 30,
      display: "block",
      background: theme.colors.primary,
      textAlign: "center",
      lineHeight: "34px",
      borderRadius: "50%",
      color: "white",

      "&:hover": {
        background: "black"
      }
    }
  },
  menu: {
    "& ul li": {
      "& a": {
        paddingBottom: 10,
        marginBottom: 10,
        display: "block",
        borderBottom: "1px solid #e1e1e1",
        color: "#555",

        "&:hover": {
          color: theme.colors.primary
        }
      },

      "&:last-child a": {
        border: 0,
        margin: 0,
        padding: 0
      }
    }
  },
  contact: {
    "& ul li": {
      display: "flex",
      alignItems: "center",
      color: "#555",
      marginBottom: "20px"
    },

    "& svg": {
      color: theme.colors.primary,
      marginRight: "10px"
    }
  },

  // hotline rung lac

  hotlineWarp: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 999999,

    "& .hotline-phone-ring": {
      position: 'relative',
      visibility: 'visible',
      backgroundColor: "transparent",
      width: "110px",
      height: "110px",
      cursor: 'pointer',
      zIndex: 11,
      WebkitBackfaceVisibility: "hidden",
      WebkitTransform: 'translateZ(0)',
      transition: "visibility .5s",
      left: 0,
      bottom: 0,
      display: "block",
    },

    "& .hotline-phone-ring-circle": {
      width: "85px",
      height: "85px",
      top: "10px",
      left: "10px",
      position: "absolute",
      backgroundColor: "transparent",
      borderRadius: "100%",
      border: "2px solid #e60808",
      WebkitAnimation: "phonering-alo-circle-anim 1.2s infinite ease-in-out",
      animation: "phonering-alo-circle-anim 1.2s infinite ease-in-out",
      transition: "all .5s",
      WebkitTransformOrigin: "50% 50%",
      MsTransformOrigin: "50% 50%",
      transformOrigin: "50% 50%",
      opacity: 0.5,
    },

    "& .hotline-phone-ring-circle-fill": {
      width: "55px",
      height: "55px",
      top: "26px",
      left: "26px",
      position: "absolute",
      backgroundColor: "rgba(230, 8, 8, 0.7)",
      borderRadius: "100%",
      border: "2px solid transparent",
      WebkitAnimation: "phonering-alo-circle-fill-anim 2.3s infinite ease-in-out",
      animation: "phonering-alo-circle-fill-anim 2.3s infinite ease-in-out",
      transition: "all .5s",
      WebkitTransformOrigin: "50% 50%",
      MsTransformOrigin: "50% 50%",
      transformOrigin: "50% 50%",
    },

    "& .hotline-phone-ring-img-circle": {
      backgroundColor: "#e60808",
      width: "33px",
      height: "33px",
      top: "37px",
      left: "37px",
      position: "absolute",
      backgroundSize: "20px",
      borderRadius: "100%",
      border: "2px solid transparent",
      WebkitAnimation: "phonering-alo-circle-img-anim 1s infinite ease-in-out",
      animation: "phonering-alo-circle-img-anim 1s infinite ease-in-out",
      WebkitTransformOrigin: "50% 50%",
      MsTransformOrigin: "50% 50%",
      transformOrigin: "50% 50%",
      display: "-webkit-box",
      display: "-webkit-flex",
      display: "-ms-flexbox",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },

    "& .hotline-phone-ring-img-circle .pps-btn-img": {
      display: "-webkit-box",
      display: "-webkit-flex",
      display: "-ms-flexbox",
      display: "flex"
    },

    "& .hotline-phone-ring-img-circle .pps-btn-img img": {
      width: "20px",
      height: "20px",
    },

    "& .hotline-bar": {
      position: "absolute",
      background: "rgba(230, 8, 8, 0.75)",
      height: "40px",
      width: "180px",
      lineHeight: "40px",
      // borderRadius: "3px",
      padding: "0 10px",
      backgroundSize: "100%",
      cursor: "pointer",
      transition: "all 0.8s",
      WebkitTransition: "all 0.8s",
      zIndex: 9,
      boxShadow: "0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: "50px !important",
      /* width: 175px !important; */
      left: "33px",
      bottom: "37px",
    },

    "& .hotline-bar > a": {
      color: "#fff",
      textDecoration: "none",
      fontSize: "15px",
      fontWeight: "bold",
      textIndent: "50px",
      display: "block",
      letterSpacing: 1,
      lineHeight: "40px",
      fontFamily: "Arial",
    },

    "& .hotline-bar > a:hover": {
      color: "#fff",
    },

    "& .hotline-bar > a:active": {
      color: "#fff",
    }

  },

  // -------Mobile-------------------
  [theme.breakpoints.down('sm')]: {
    container: {
      "& > div": {
        "& > div": {
          width: "calc(100% / 2 - 30px)",
        }
      }
    },

    hotlineWarp: {
      "& .hotline-bar": {
        display: "none"
      }
    }
  },
});

export default styles;
